export const STORY_CONTROL_EXEMPT_SELECTOR = '[data-story-control-exempt="true"]'

const isStoryControlLayer = element =>
    Boolean(
        element?.classList?.contains?.('story-control') ||
            element?.classList?.contains?.('story-control-container'),
    )

const canResolveClosest = element =>
    typeof element?.closest === 'function' && typeof element?.classList?.contains === 'function'

export const getEventClientPoint = event => {
    const touch = event?.changedTouches?.[0] || event?.touches?.[0]
    if (touch) {
        return {
            clientX: touch.clientX,
            clientY: touch.clientY,
        }
    }

    if (Number.isFinite(event?.clientX) && Number.isFinite(event?.clientY)) {
        return {
            clientX: event.clientX,
            clientY: event.clientY,
        }
    }

    return null
}

export const pickStoryControlExemptTarget = elements =>
    elements
        .find(element => {
            if (!canResolveClosest(element) || isStoryControlLayer(element)) return false
            return Boolean(element.closest(STORY_CONTROL_EXEMPT_SELECTOR))
        })
        ?.closest?.(STORY_CONTROL_EXEMPT_SELECTOR) || null

export const getStoryControlExemptTarget = (event, doc = document) => {
    if (typeof doc?.elementsFromPoint !== 'function') {
        return null
    }

    const point = getEventClientPoint(event)
    if (!point) return null

    return pickStoryControlExemptTarget(doc.elementsFromPoint(point.clientX, point.clientY))
}

export const isStoryControlExemptEvent = (event, doc = document) =>
    Boolean(getStoryControlExemptTarget(event, doc))
